module.exports = __webpack_public_path__ + "img/비스트로드.ef6ead78.png";